export enum EMaterielEauPonctuel {
    Bouteille = 1,
    Perche = 2,
    Manuel = 3,
}